import { AccountSourceType } from 'owa-account-source-list-types';

export default function isFirstPartyAccountSourceType(
    accountSource: AccountSourceType
): accountSource is AccountSourceType.Office365 | AccountSourceType.OutlookDotCom {
    return (
        accountSource == AccountSourceType.Office365 ||
        accountSource == AccountSourceType.OutlookDotCom
    );
}
